/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForNewrelic extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForNewrelic");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForNewrelic.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForNewrelic>): ServiceAccountNativeDetailsForNewrelic {
        let obj = Object.assign(new ServiceAccountNativeDetailsForNewrelic(), model);
        ServiceAccountNativeDetailsForNewrelic.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForNewrelic>): ServiceAccountNativeDetailsForNewrelic {
        if (!model) return null;
        return ServiceAccountNativeDetailsForNewrelic.newInstance(<ServiceAccountNativeDetailsForNewrelic> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForNewrelic) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForNewrelic.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForNewrelic): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForNewrelic.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
